import { configFetch as fetch } from '@laigu/utils';

export const getAttrConfig = () => {
  return fetch({
    url: `/users/attr_config?category=main`
  });
};
